module.exports = __webpack_public_path__ + "static/img/request-a-demo.be94c01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/request-a-demo.png
// module id = NX1x
// module chunks = 0